import { FCX, ID } from "@datassential/platform-ui-lib";
import { ReactNode } from "react";
import './Tabs.scss';
import cn from "classnames";

interface ITabItem {
    id: ID;
    title: ReactNode;
}

type Modifier = 'height-l';

const FoodTabs: FCX<{
    data: ITabItem[];
    activeTabId: ID;
    onItemClick: (id: ID) => void;
    modifiers?: Modifier[];
}> = ({
    data,
    activeTabId,
    onItemClick,
    modifiers = [],
    testId,
    className,
    ...rest
}) => {
    return (
        <div
            className={cn(
                className,
                "FoodTabs",
                ...modifiers.map(i => `is-${i}`),
            )}
            data-testid={testId}
            {...rest}
        >
            {data.map(({ id, title }, index) => (
                <div
                    key={id}
                    className={`FoodTabs__item ${activeTabId === id ? 'is-active' : ''}`}
                    onClick={() => onItemClick(id)}
                    data-testid={`buttonFoodTabsItem-${index}`}
                >
                    {title}
                </div>
            ))}
        </div>
    );
}

export default FoodTabs;